<template>
  <p
    class="w-100 adobe-clean text-center pair-title"
    v-html="copy"
    @transitionend="handleFade"
    :style="{ opacity: copyAlpha }"
  ></p>
</template>

<script>
  import { industryTypes } from '@/lib/consts'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'PieTitle',
    mixins: [ ContentMixin, StateMixin ],
    props: {
      botHeld: { type: Boolean, required: false },
      data: { type: [ Object, String ], required: true },
      text: { type: String, required: true }
    },
    data () {
      return {
        indRegex: /(<[a-z]+\s[^>]*"industry-word"[^>]*>)[\w\.]*(<\/([a-z]+)>)/gi,
        swapRegex: /(<[a-z]+\s[^>]*"word-swap"[^>]*>)([\w\.]*)(<\/([a-z]+)>)/gi,
        copyAlpha: 1,
        ind: null,
        copy: ''
      }
    },
    watch: {
      botHeld () {
        this.initFade()
        this.ind = this.ind === 'mktg' ? 'it' : 'mktg'
      },
      industry () {
        this.ind = this.industry
        this.setIndWords()
      }
    },
    methods: {
      initFade () {
        if ( this.copy.match( /<[^>]*"(?:industry-word|word-swap)"[^>]*>/i ) ) {
          this.copyAlpha = 0
        }
      },
      handleFade ( { target: { style: { opacity } } } ) {
        if ( opacity === '0' ) {
          this.copy = this.text
          this.setIndWords()
          this.$nextTick( () => {
            this.copyAlpha = 1
          } )
        }
      },
      setIndWords () {
        this.copy = this.text.replace( this.indRegex, '$1' + industryTypes[ this.ind ].shortName + '$2' )

        this.copy = this.copy.replace( this.swapRegex, ( m, oTag, content, cTag ) => {
          let base = oTag.match( /data-base="(\w*)"/i )
          let alt = oTag.match( /data-alt="(\w*)"/i )

          switch ( true ) {
            case (base instanceof Array && !this.botHeld):
              return oTag + base[ 1 ] + cTag
            case (alt instanceof Array && this.botHeld):
              return oTag + alt[ 1 ] + cTag
            default:
              return oTag + content + cTag
          }
        } )
      }
    },
    mounted () {
      this.ind = this.industry
      this.setIndWords()
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";
  .pair-title {
    transition : opacity #{$data-trans-time / 6};

    .industry-word {
      font-weight: 900;
    }

    @include screen-md {
      font-size : rem(20);
    }

    @include screen-lg-xl {
      font-size : rem(24);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/PieTitle.vue